@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId" [hidden]="label() === undefined">{{ label() }}</label>
  <lib-rich-text-input [error]="showError" [placeholder]="placeholder() ?? ''" [formControl]="inputFormControl()">
  </lib-rich-text-input>
  <div class="d-flex align-items-center">
    <div class="d-flex flex-column gap-1">
      @if (hintText()) {
        <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
          {{ hintText() }}
        </div>
      }
      @if (showError) {
        <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
      }
    </div>
    @if (maxCharacters() !== null) {
      <div
        class="ms-auto character-count"
        [class.character-count-error]="visibleCharacterCount() > (maxCharacters() ?? 0)">
        {{ visibleCharacterCount() | number }}/{{ maxCharacters() | number }}
      </div>
    }
  </div>
</div>
